import { Injectable } from '@angular/core';
import {
  AuditLog,
  AuditLogCategory,
  ConfigurationAuditLog,
  ConfigurationAuditLogParams,
  ConfigurationAuditLogRepository,
} from '@app/domain';
import { PaginatedResponse } from '@app/shared/models/global.model';
import { map, Observable } from 'rxjs';
import { ConfigurationAuditLogService } from '../api-clients';
import { ConfigurationAuditLogMapper } from '../mappers';

@Injectable()
export class ConfigurationAuditLogRepositoryImpl
  implements ConfigurationAuditLogRepository
{
  private readonly _configurationAuditLogMapper =
    new ConfigurationAuditLogMapper();

  constructor(
    private readonly _configurationAuditLogService: ConfigurationAuditLogService
  ) {}

  getConfigurationAuditLogList(
    params: ConfigurationAuditLogParams
  ): Observable<PaginatedResponse<ConfigurationAuditLog>> {
    const configurationAuditLogListDTO =
      this._configurationAuditLogService.getConfigurationAuditLogList(params);
    return configurationAuditLogListDTO.pipe(
      map(dto =>
        this._configurationAuditLogMapper.configurationAuditLogToDomain(dto)
      )
    );
  }

  getConfigurationAuditLogItem(id: number): Observable<AuditLog> {
    const configurationAuditLogItemDTO =
      this._configurationAuditLogService.getConfigurationAuditLogItem(id);

    return configurationAuditLogItemDTO.pipe(
      map(dto =>
        this._configurationAuditLogMapper.configurationAuditLogItemToDomain(dto)
      )
    );
  }

  getAuditLogTaskNames(category: AuditLogCategory): Observable<string[]> {
    return this._configurationAuditLogService.getAuditLogTaskNames(category);
  }
}
